export function getFunctionName() {
  const e = new Error('functionName')
  try {
    //defaut as empty
    let functionName = ''
    // Split the stack trace into an array of lines by new line character
    const lines = e.stack.split('\n').map((line) => line.trim())

    // Find the index of the line that starts with 'at Object.<'
    let indexFound = lines.findIndex((line) => line.startsWith('at Object.<'))

    //if not found try to find using "processTicksAndRejections"
    if (indexFound === -1) indexFound = lines.findIndex((line) => line.startsWith('at processTicksAndRejections'))

    if (indexFound === -1) throw new Error("Could not find 'at Object.<' in the stack trace")

    //from this index, subtract 1 do the replacement just to get the function name
    const previousLine = lines[indexFound - 1]
    const functionMatch = previousLine.match(/at ([\w.]+) /)

    if (functionMatch && functionMatch[1]) {
      functionName = functionMatch[1]
    }

    return functionName
  } catch (e) {
    return ''
  }
}
